import { DateTimeFormatter, Loader } from '@nile/components/src';
import { SVGIcon } from '@superops/super-icons';
import { Card, TextStyle } from '@superops/ui-design-system';
import { isEmpty } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const DataContainer = (props) => {
  return (
    <>
      <div className="mb10">
        <TextStyle variation="subdued" uppercase>
          {/* <FormattedMessage id="scheduling.header.sla.due" /> */}
          <FormattedMessage id={props?.heading} />

          {` (${props?.data?.length})`}
        </TextStyle>
      </div>

      <div>
        {props?.data?.map((el) => {
          return (
            <div className="flex g10 actr mb5">
              <div className="flex g5 actr">
                <div>
                  <SVGIcon name="ClockRound" size="sm" />
                </div>
                <div className="ml-5">
                  <DateTimeFormatter
                    date={el?.resolutionDueTime}
                    type={props?.type || 'dateTime'}
                  />
                </div>
              </div>

              <div className="flex g5 actr">
                <TextStyle variation="subdued">
                  <div className="mr-5">#{el?.displayId}</div>
                </TextStyle>
                <TextStyle weight="SemiBold">
                  <div>{el?.subject}</div>
                </TextStyle>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

const SLATicketDetails = (props) => {
  const { loading, dueData, overDueData } = props;

  if (loading) {
    return (
      <Card>
        <div className="flex actr jctr p20 min-height-50">
          <Loader />
        </div>
      </Card>
    );
  }
  return (
    <Card>
      <div className="pt10 pb20 pl20 pr-20">
        {!isEmpty(dueData) && (
          <div className="mb10">
            <DataContainer
              data={dueData}
              type="time"
              heading={'scheduling.header.sla.due'}
            />
          </div>
        )}
        {!isEmpty(overDueData) && (
          <div className="mb10">
            <DataContainer
              data={overDueData}
              type="dateTime"
              heading={'scheduling.header.sla.overdue'}
            />
          </div>
        )}

        {isEmpty(overDueData) && isEmpty(dueData) && (
          <div className="mt10">
            <TextStyle variation="subdued">
              <FormattedMessage id="scheduling.header.no.sla" />
            </TextStyle>
          </div>
        )}
      </div>
    </Card>
  );
};

export default SLATicketDetails;
